import { createAsyncThunk } from '@reduxjs/toolkit';

import { _apiPathManagerConfig } from 'Shared/ApiPaths/ApiPathManagerSetup';

import { IGetShakhsSalesBimehNamehByShomarehBimehNamehQuery } from '../SakhsSalesBimehNameh/Queries/IGetShakhsSalesBimehNamehByShomarehBimehNamehQuery';
import { KhodroHttpGetService } from '../Services/KhodroHttpService';

const GetShakhsSalesBimehNamehByShomarehBimehNameh = createAsyncThunk(
  'ShakhSalesBimehNamehDetail/GetShakhsSalesBimehNamehByShomarehBimehNameh',
  async (query: IGetShakhsSalesBimehNamehByShomarehBimehNamehQuery) => {
    return await KhodroHttpGetService({
      url: `${_apiPathManagerConfig?.Khodro.BimehNamehHayeShakhsSales.GetShakhsSalesBimehNamehByShomarehBimehNameh}`,
      params: query,
    });
  }
);

export default GetShakhsSalesBimehNamehByShomarehBimehNameh;
